import { colors } from '@atlaskit/theme';

export const borderWidth = 1;
export const borderColor = colors.B100;
export const size = 8;
export const color = colors.B75;
